/* L'ESTHETIQ — open Dawn's cart drawer from every add-to-cart path:
   the custom PDP form (incl. the sticky bar), the bag buttons on product
   cards, and the "add routine" button. Falls back to the normal page flow
   if anything goes wrong. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionsParam(cart) { return cart.getSectionsToRender().map(function (s) { return s.id; }).join(','); }
  function render(cart, json) {
    if (json && json.status) { throw json; }
    if (typeof cart.setActiveElement === 'function') { cart.setActiveElement(document.activeElement); }
    cart.classList.remove('is-empty');
    cart.renderContents(json);
  }
  window.medAddToCart = function (items) {
    var cart = drawer(); if (!cart) { return Promise.resolve(false); }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sectionsParam(cart), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (json) { render(cart, json); return true; });
  };
  /* "Complete your routine" links in the drawer: GET /cart/add?id= works without JS;
     with JS, add in place and let the drawer re-render (the list refreshes itself). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-med-upsell-add]');
    if (!a || !drawer()) { return; }
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') { return; }
    a.setAttribute('aria-busy', 'true');
    window.medAddToCart([{ id: +a.getAttribute('data-med-upsell-add'), quantity: 1 }])
      .catch(function () { window.location.href = a.href; })
      .finally(function () { a.removeAttribute('aria-busy'); });
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!(form instanceof HTMLFormElement)) { return; }
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\b|$)/.test(action)) { return; }
    if (form.closest('product-form')) { return; }          /* Dawn's own component handles these */
    var cart = drawer(); if (!cart) { return; }
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var fd = new FormData(form);
    fd.append('sections', sectionsParam(cart)); fd.append('sections_url', location.pathname);
    fetch(root + 'cart/add', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) { render(cart, json); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }, true);
})();
